import { completePaymentPlatform } from "../../static/img/home";
import {
  BRAND_LOGO_ASSETS_URL,
  HOME_PAGE_ASSETS_URL,
  LOTTIE_ASSETS_URL,
  NEW_HOME_HOME_URL,
} from "./Url";

export const homePageImages = {
  heroIllustration: `${LOTTIE_ASSETS_URL}/home-hero.json`,
  paymentPlatform: completePaymentPlatform,
  noCodeAsset: `${NEW_HOME_HOME_URL}/cashgram-asset.svg`,
};

export const clientLogos = [
  {
    id: "1",
    src: `${BRAND_LOGO_ASSETS_URL}/zomato.svg`,
    alt: "zomato",
    width: "110",
    height: "23",
  },
  {
    id: "2",
    src: `${BRAND_LOGO_ASSETS_URL}/cred-black.svg`,
    alt: "cred",
    width: "100",
    height: "46",
  },
  {
    id: "3",
    src: `${BRAND_LOGO_ASSETS_URL}/nykaa-dark.svg`,
    alt: "nykaa",
    width: "80",
    height: "26",
  },
  {
    id: "4",
    src: `${BRAND_LOGO_ASSETS_URL}/delhivery.svg`,
    alt: "delhivery",
    width: "122",
    height: "20",
  },
  {
    id: "5",
    src: `${BRAND_LOGO_ASSETS_URL}/acko.svg`,
    alt: "acko",
    width: "77",
    height: "25",
  },
  {
    id: "6",
    src: `${BRAND_LOGO_ASSETS_URL}/shell.svg`,
    alt: "shell",
    width: "98",
    height: "26",
  },
  {
    id: "7",
    src: `${BRAND_LOGO_ASSETS_URL}/zoomcar.svg`,
    alt: "zoomcar",
    width: "115",
    height: "26",
  },
  {
    id: "8",
    src: `${BRAND_LOGO_ASSETS_URL}/medlife.svg`,
    alt: "medlife",
    width: "80",
    height: "41",
  },
  {
    id: "9",
    src: `${BRAND_LOGO_ASSETS_URL}/dunzo-black.svg`,
    alt: "dunzo",
    width: "104",
    height: "23",
  },
  {
    id: "10",
    src: `${BRAND_LOGO_ASSETS_URL}/dream-11.svg`,
    alt: "dream11",
    width: "130",
    height: "35",
  },
  {
    id: "11",
    src: `${BRAND_LOGO_ASSETS_URL}/lt-financial.svg`,
    alt: "lt-financial",
    width: "141",
    height: "25",
  },
  {
    id: "12",
    src: `${BRAND_LOGO_ASSETS_URL}/zomato.svg`,
    alt: "zomato",
    width: "110",
    height: "23",
  },
  {
    id: "13",
    src: `${BRAND_LOGO_ASSETS_URL}/cred-black.svg`,
    alt: "cred",
    width: "100",
    height: "46",
  },
  {
    id: "14",
    src: `${BRAND_LOGO_ASSETS_URL}/nykaa-dark.svg`,
    alt: "nykaa",
    width: "80",
    height: "26",
  },
  {
    id: "15",
    src: `${BRAND_LOGO_ASSETS_URL}/delhivery.svg`,
    alt: "delhivery",
    width: "122",
    height: "20",
  },
  {
    id: "16",
    src: `${BRAND_LOGO_ASSETS_URL}/acko.svg`,
    alt: "acko",
    width: "77",
    height: "25",
  },
  {
    id: "17",
    src: `${BRAND_LOGO_ASSETS_URL}/shell.svg`,
    alt: "shell",
    width: "98",
    height: "26",
  },
  {
    id: "18",
    src: `${BRAND_LOGO_ASSETS_URL}/zoomcar.svg`,
    alt: "zoomcar",
    width: "115",
    height: "26",
  },
  {
    id: "19",
    src: `${BRAND_LOGO_ASSETS_URL}/medlife.svg`,
    alt: "medlife",
    width: "80",
    height: "41",
  },
  {
    id: "20",
    src: `${BRAND_LOGO_ASSETS_URL}/dunzo-black.svg`,
    alt: "dunzo",
    width: "104",
    height: "23",
  },
  {
    id: "21",
    src: `${BRAND_LOGO_ASSETS_URL}/dream-11.svg`,
    alt: "dream11",
    width: "130",
    height: "35",
  },
  {
    id: "22",
    src: `${BRAND_LOGO_ASSETS_URL}/lt-financial.svg`,
    alt: "lt-financial",
    width: "141",
    height: "25",
  },
];

export const featuresData = [
  {
    icon: `${HOME_PAGE_ASSETS_URL}/shopifyPayments.svg`,
    header: "Shopify payments",
    description:
      "Go live in under 5 minutes and accept payments using UPI, Cards, Net banking, BNPL, Wallets, EMI, COD etc. with plugin install.",
    url: "https://www.cashfree.com/shopify-payment-gateway-india/",
  },
  {
    icon: `${HOME_PAGE_ASSETS_URL}/websiteAppPayments.svg`,
    header: "Website and app payments",
    description:
      "Integrate quickly with a wide range of SDKs. RESTful APIs, plug-ins, support for all major platforms.",
    url: "https://www.cashfree.com/payment-gateway-india",
  },
  {
    icon: `${HOME_PAGE_ASSETS_URL}/socialMedia.svg`,
    header: "Social Media payments",
    description:
      "Create and share payment links easily via SMS and email for your online brand and collect easy payments.",
    url: "https://www.cashfree.com/payment-links/",
  },
  {
    icon: `${HOME_PAGE_ASSETS_URL}/internationalPaymentGateway.svg`,
    header: "International payments",
    description:
      "Collect payments in over 100 currencies from customers worldwide.",
    url: "https://www.cashfree.com/accept-international-payments/",
  },
  {
    icon: `${HOME_PAGE_ASSETS_URL}/internationalPayment.svg`,
    header: "Make Payouts",
    description: "Send money instantly 24x7 to any bank, UPI, card, or wallet.",
    url: "https://www.cashfree.com/payouts/",
  },
  {
    icon: `${HOME_PAGE_ASSETS_URL}/verifyIdentity.svg`,
    header: "Verify Identity",
    description:
      "	Secure business from frauds and stay compliant with 360° identity verification.",
    url: "https://www.cashfree.com/kyc-verification/",
  },
];

export const enterprisesData = [
  {
    iconSrc: `${HOME_PAGE_ASSETS_URL}/intelligentcheckout.svg`,
    className: "w-full md:w-1/3 mb-4 md:mb-0 px-3.5",
    title: "Build a custom checkout that converts",
    description:
      "Convert cart to order, 4X faster, with 100M+ verified addresses, 200+ discount options, secure OTP login, and multi-PG routing etc.",
    url: "https://www.cashfree.com/growth/one-click-checkout/",
  },
  {
    iconSrc: `${HOME_PAGE_ASSETS_URL}/driveYourConversions.svg`,
    className: "w-full md:w-1/3 mb-4 md:mb-0 px-3.5",
    title: "Recover abandoned orders",
    description:
      "Convert lost orders with exclusive offers by reaching customers on WhatsApp or SMS, letting them pick up right where they left off.",
    url: "https://www.cashfree.com/growth/one-click-checkout/",
  },
  {
    iconSrc: `${HOME_PAGE_ASSETS_URL}/protectYourProfits.svg`,
    className: "w-full md:w-1/3 px-3.5",
    title: "Reduce RTO",
    description:
      "Cut down RTO losses by 55% using intelligent COD masking for high RTO risk customers, add COD fee and  set nudges to convert COD to prepaid.",
    url: "https://www.cashfree.com/growth/one-click-checkout/",
  },
];

export const quotes = [
  {
    id: 0,
    partner: {
      src:
        "https://cashfreelogo.cashfree.com/website/landings-cache/landings/homepage/pritish.png",
      width: "502",
      height: "326",
      alt: "anoj",
    },
    companyLogo: {
      src: `${HOME_PAGE_ASSETS_URL}/pilgrim3.png`,
      width: "91",
      height: "39",
      alt: "Pilgrim",
    },
    name: "Pritish Varthak",
    designation: "Director (D2C), Pilgrim",
    quote:
      "FlowWise by Cashfree Payments is a game-changer! It seamlessly uses multiple payment gateways while maintaining a smooth checkout experience. Behind the scenes, it intelligently distributes the load, optimizes success rates, and ensures resilience with multiple bank routing configurations. Truly a powerhouse solution!",
  },
  {
    id: 1,
    partner: {
      src:
        "https://cashfreelogo.cashfree.com/website/landings-cache/landings/homepage/jitesh.png",
      width: "502",
      height: "326",
      alt: "mansi",
    },
    companyLogo: {
      src: `${HOME_PAGE_ASSETS_URL}/uni.png`,
      width: "91",
      height: "39",
      alt: "Unicards",
    },
    name: "Jitesh Gandhi",
    designation: "VP, Product Management at Unicards",

    quote:
      " Cashfree Payouts ensures one of the highest transaction success rates in the industry, enabling faster, failure-free transfers to customers' bank accounts, building trust with zero delays.",
  },
  {
    id: 2,
    partner: {
      src:
        "https://cashfreelogo.cashfree.com/website/landings-cache/landings/hut.png",
      width: "502",
      height: "326",
      alt: "varun",
    },
    companyLogo: {
      src: `${HOME_PAGE_ASSETS_URL}/heads-up-for-tails.png`,
      width: "108",
      height: "44",
      alt: "Heads Up For Tails",
    },
    name: "Varun Rustagi",
    designation: "Associate Director of Product Management, Heads Up For Tails",
    quote:
      "Switching to Cashfree Payments was a game-changer for us. Our card payment success rate jumped to 90% and UPI to 85%, way above the 70% industry average. They made handling compliance a breeze and always have our back with prompt, friendly support from their customer success team and relationship manager.",
  },
];

export const codeLogos = [
  {
    id: 0,
    imgSrc: `${HOME_PAGE_ASSETS_URL}/curl.svg`,
    alt: "curl",
    className: "w-[96px] h-[30px]",
  },
  {
    id: 1,
    imgSrc: `${HOME_PAGE_ASSETS_URL}/java.svg`,
    alt: "java",
    className: "w-[58px] h-[30px]",
  },
  {
    id: 2,
    imgSrc: `${HOME_PAGE_ASSETS_URL}/python.svg`,
    alt: "python",
    className: "w-[123px] h-[35px] mt-1",
  },
  {
    id: 3,
    imgSrc: `${HOME_PAGE_ASSETS_URL}/php.svg`,
    alt: "php",
    className: "w-[56px] h-[29px]",
  },
  {
    id: 4,
    imgSrc: `${HOME_PAGE_ASSETS_URL}/node.svg`,
    alt: "node",
    className: "w-[95px] h-[27px]",
  },
];

export const devCardsData = [
  {
    icon: `${HOME_PAGE_ASSETS_URL}/integrations.svg`,
    header: "Integrations",
    description:
      "Discover the range of integrations supported by our platform.",
    url: "https://www.cashfree.com/docs/payments/online/mobile/android",
  },
  {
    icon: `${HOME_PAGE_ASSETS_URL}/apIReference.svg`,
    header: "API Reference",
    description: "Detailed documentation to help you integrate quickly.",
    url:
      "https://www.cashfree.com/docs/api-reference/payments/latest/orders/create",
  },
  {
    icon: `${HOME_PAGE_ASSETS_URL}/devStudio.svg`,
    header: "Dev Studio",
    description:
      "Test out your integrations and SDKs on our interactive developer playground.",
    url: "https://www.cashfree.com/devstudio",
  },
];
